const toastErrors = (e: any) => {
	const { $i18n, $toast } = useNuxtApp()

	const error = (text: string) => {
		$toast.error({ message: text })
	}
	if (!e.response) {
		if (!e.message || e.message === "") error($i18n.t("something_went_wrong") as string)
		else error(e.message)
	} else if (!e.response._data || !e.response._data.errors || e.response._data.errors.length === 0) {
		if (!e.response.statusText || e.response.statusText === "") error($i18n.t("something_went_wrong"))
		else if (e.response.status === 403) {
			error($i18n.t("something_went_wrong"))
		} else error(e.response.statusText)
	} else {
		Object.values(e.response._data.errors).forEach((i: any) => {
			Object.values(i).forEach((t: any) => {
				error(t)
			})
		})
	}
}

export default toastErrors
